/* eslint-env jquery */
(function ($) {
  $(document).ready(footerInit);
  $(window).on('resize', footerNav);

  function footerInit() {
    footerNav();
    doNotSell();
  }

  function footerNav() {
    if (window.matchMedia('(max-width: 575.98px)').matches) {
      $('.site-footer-nav:not(.do-not-collapse)').each(function () {
        if (!$(this).hasClass('collapse-nav')) {
          $(this).addClass('collapse-nav');
        }

        const buttonCopy = $(this).children('h6').text().toLowerCase().replace(/ /g, '-');
        if (!$(this).children('h6').children('button').length) {
          $(this)
            .children('h6')
            .wrapInner(
              `<button class="collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#${buttonCopy}-collapse" aria-expanded="false" aria-controls="${buttonCopy}-collapse"></button>`
            );
        }

        if (!$(this).children(`.menu-${buttonCopy}-container`).hasClass('collapse')) {
          $(this)
            .children(`.menu-${buttonCopy}-container`)
            .addClass('collapse')
            .attr('id', `${buttonCopy}-collapse`);
        }
      });
    } else {
      $('.site-footer-nav:not(.do-not-collapse)').each(function () {
        $(this).removeClass('collapse-nav');
        const buttonCopy = $(this).children('h6').text().toLowerCase().replace(/ /g, '-');
        $(this).children('h6').children('button').contents().unwrap();
        $(this)
          .children(`.menu-${buttonCopy}-container`)
          .removeClass('collapse')
          .removeClass('show')
          .removeAttr('id');
      });
    }
  }

  function doNotSell() {
    if ($('footer .do-not-sell').length) {
      $('footer .do-not-sell > a')
        .removeAttr('href')
        .replaceWith(
          '<a href="javascript:void(0);" role="button" id="ot-sdk-btn" class="ot-sdk-show-settings">Do Not Sell or Share My Personal Information</a>'
        );
    }
  }
})(jQuery);
